export default __webpack_public_path__ + "static/media/B3.4004167e.png";